export const yaTrackEvent = (
  goal: string,
  params: Record<string, unknown> = {},
  type: string = 'reachGoal',
) => {
  if (window.ym) {
    if (Object.keys(params).length) {
      window.ym(import.meta.env.VITE_YM_ID, type, goal, params);
    } else {
      window.ym(import.meta.env.VITE_YM_ID, type, goal);
    }
  }
};

export const vkTrackEvent = (goal: string) => {
  if (window.VK) {
    window.VK.Retargeting.Event(goal);
  }
};

export const topTrackEvent = (goal: string, type: string = 'reachGoal') => {
  if (window._tmr) {
    window._tmr.push({ id: `${import.meta.env.VITE_TOP_ID}`, type: type, goal: goal });
  }
};
